// extracted by mini-css-extract-plugin
export default {"zoomModal":"P1-z","image":"Q1-z","button":"R1-z","isOverlayShown":"S1-z"};